var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_502_6033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 88.8418C74.3675 88.8418 92.5 70.7093 92.5 48.3418C92.5 25.9743 74.3675 7.8418 52 7.8418C29.6325 7.8418 11.5 25.9743 11.5 48.3418C11.5 70.7093 29.6325 88.8418 52 88.8418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 84.3418C71.8823 84.3418 88 68.2241 88 48.3418C88 28.4595 71.8823 12.3418 52 12.3418C32.1178 12.3418 16 28.4595 16 48.3418C16 68.2241 32.1178 84.3418 52 84.3418Z",
    fill: "url(#paint0_linear_502_6033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4813 43.5037C40.3788 43.5037 41.917 40.9958 41.917 37.9021C41.917 34.8084 40.3788 32.3004 38.4813 32.3004C36.5839 32.3004 35.0456 34.8084 35.0456 37.9021C35.0456 40.9958 36.5839 43.5037 38.4813 43.5037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5187 43.5037C67.4161 43.5037 68.9543 40.9958 68.9543 37.9021C68.9543 34.8084 67.4161 32.3004 65.5187 32.3004C63.6212 32.3004 62.083 34.8084 62.083 37.9021C62.083 40.9958 63.6212 43.5037 65.5187 43.5037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6183 61.7278C41.6183 61.7278 51.2531 67.7029 61.3361 61.7278",
    stroke: "#5B0600",
    strokeWidth: 3.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_502_6033",
    x: -3.8,
    y: -3.8582,
    width: 111.6,
    height: 111.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_6033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_6033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_6033",
    x1: 20.8351,
    y1: 66.3225,
    x2: 83.2299,
    y2: 30.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198685,
    stopColor: "#FFBA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5514,
    stopColor: "#FFCE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkHover);
export default __webpack_public_path__ + "static/media/ok-hover.5dd763f2522b75d263a6eba5baad5193.svg";
export { ForwardRef as ReactComponent };